import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const FeaturedSectionPageStripTemplate = observer(function FeaturedSectionPageStripTemplate({
    store,
    renderPage,
}) {
    const { currentPage, pageCount } = store;

    if (pageCount === 0) {
        return null;
    }

    return (
        <div className="c-featured-pages">
            <div className="c-featured-pages__nav">
                <div className="c-featured-pages__nav__page">{renderPage(currentPage)}</div>
            </div>
        </div>
    );
});

FeaturedSectionPageStripTemplate.propTypes = {
    store: PropTypes.object.isRequired,
    renderPage: PropTypes.func.isRequired,
};

export default FeaturedSectionPageStripTemplate;
